export default {
  comingSoon: 'Pronto',
};
